import React from 'react';
import { linkedinUrl, githubUrl, myImage, emailUrl, Button } from './Imports';

function Intro() {
    return (
        <div className="intro">
            <header className="header">
                <div className='line' />
                <a href={linkedinUrl} target="_blank" rel="noopener noreferrer">
                    <h3><i>LinkedIn</i></h3>
                </a>
                <a href={githubUrl} target="_blank" rel="noopener noreferrer">
                    <h3><i>Github</i></h3>
                </a>
                <div className='line' />
            </header>

            <div className='introContainer'>
                <div className="brief">
                    <h3><i>Hi, I'm</i></h3>
                    <h1>Ayan Dhiman —</h1>
                    <h1>Full Stack Developer</h1>
                    <h3><i>based in Bengaluru, Karnataka, India </i>⚲ </h3>
                    <div className='introB'>
                        <a href="/assets/Resume-Ayan_Dhiman.pdf" download="Resume-Ayan_Dhiman.pdf">
                            <Button className='button' variant="contained">
                                Download CV
                            </Button>
                        </a>
                        <Button className='button' variant="contained" href={emailUrl}>
                            Email
                        </Button>
                    </div>
                </div>
                <div className="circular-image-container">
                    <img src={myImage} alt="Circular" className="circular-image" />
                </div>
            </div>
        </div>
    );
}

export default Intro;
